import { z } from "zod";

export function unwrapApiError(error: unknown, fallback = "Something went wrong! Please try again later.") {
  const LiteralSchema = z.string().safeParse(error);
  if (LiteralSchema.success) return LiteralSchema.data || fallback;

  const MessageSchema = z.object({ message: z.string() }).safeParse(error);
  if (MessageSchema.success) return MessageSchema.data.message || fallback;

  const ErrorSchema = z.object({ error: z.string() }).safeParse(error);
  if (ErrorSchema.success) return ErrorSchema.data.error || fallback;

  const ValidationError = z.object({ error: z.array(z.object({ message: z.string() })).min(1) }).safeParse(error);
  if (ValidationError.success) return ValidationError.data.error[0].message || fallback;

  return fallback;
}
